import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { Icon } from '../components/installer/icons.js'
import { JOB } from '../lib/job.js'
import { useStep } from '../state/useStep.js'

export const JobBriefScreen = (): ReactElement => {
  const { goto } = useStep()

  const footer = (
    <Button size="xl" onClick={() => goto('proof-bundle')}>
      Continue to Proof Bundle
    </Button>
  )

  return (
    <AppShell title="Job brief" progress={0.15} footer={footer}>
      <div className="installer-surface page fade-in">
        {/* Job card */}
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <span className="job-chip">Furniture Delivery &amp; Install</span>
            <span className="job-meta">{JOB.jobId}</span>
          </div>
          <div className="job-item">
            <div className="job-thumb">
              <img src={JOB.heroSrc} alt={JOB.appliance} loading="eager" decoding="async" />
            </div>
            <div style={{ flex: 1 }}>
              <div className="job-name">{JOB.appliance}</div>
              <div className="job-order">Order #{JOB.orderNumber}</div>
            </div>
          </div>
          <div className="address-block">
            <div className="address-line">{JOB.address}</div>
            <div className="customer-name">{JOB.customer}</div>
          </div>
          <div className="provider-block">
            Provider: {JOB.provider}
            <br />
            Installer: {JOB.installer}
          </div>
        </div>

        {/* Intake summary */}
        <div className="section-label">INTAKE SUMMARY</div>
        <div className="card" style={{ padding: 12 }}>
          <div className="pill-row">
            {JOB.intake.map((item) => (
              <div className="pill" key={item.key}>
                <span className="pill-key">{item.key}</span>
                <span className="pill-sep">·</span>
                <span className="pill-val">{item.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Job-specific risk */}
        <div className="section-label">JOB-SPECIFIC RISK</div>
        <div className="blocker warning">
          <div className="blocker-header">
            <div className="blocker-title">{JOB.risk.title}</div>
            <div className="badge-warning">WARNING</div>
          </div>
          <div className="blocker-body">{JOB.risk.body}</div>
          <div className="blocker-meta">
            <span>Source: {JOB.risk.source}</span>
          </div>
        </div>

        {/* Ready to bring */}
        <div className="section-label">READY TO BRING</div>
        <div className="card info">
          <div className="bring-group">
            <div className="bring-label">
              <Icon.Box />
              STAGE PARTS
            </div>
            <div className="bring-items">
              {JOB.stageParts.map((part) => (
                <span className="bring-chip" key={part}>{part}</span>
              ))}
            </div>
          </div>
          <div className="bring-group">
            <div className="bring-label">
              <Icon.Wrench />
              BRING TOOLS
            </div>
            <div className="bring-items">
              {JOB.tools.map((tool) => (
                <span className="bring-chip" key={tool}>{tool}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  )
}
